import 'css-chunksrc/client/scenes/projectPopup/styles.scss';export default {
  "projectPopup": "_projectPopup_cxr14_1",
  "header": "_header_cxr14_13",
  "dates": "_dates_cxr14_22",
  "group": "_group_cxr14_33",
  "name": "_name_cxr14_42",
  "label": "_label_cxr14_49",
  "subTitle": "_subTitle_cxr14_55",
  "description": "_description_cxr14_62",
  "date": "_date_cxr14_22"
};